import { createGlobalState } from '@vueuse/core'
import { getDatabase, ref } from "firebase/database";
import { reactive, ref as refVue } from 'vue'
import { getFirestore, doc, setDoc, updateDoc, deleteField, collection, getDocs, query, where, writeBatch, QuerySnapshot , onSnapshot, type Unsubscribe} from "firebase/firestore";
import { buildJobChunkDocs } from "~~/modules/core/composables/useJobsChunk";
import { FIRESTORE_COLLECTIONS } from "~/interface/FirestoreCollections";


export const useFirebase = createGlobalState(
    () => {
        // state
        const storeId = refVue(null)

        // getters
        // const doubleCount = computed(() => count.value * 2)

        // actions
        function setStoreId(id) {
            storeId.value = id;
        }


        function jobchainRef() {
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/jobchain`);
        }

        function itemsRef(){
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/items`);
        }

      

        function summaryRef(){
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/summary`);
        }

        function tablesRef(){
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/tables`);
        }

        function tableStateRef() { 
              
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/tableState`);
        }

        function tableMetaRef() { 
              
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/tableMeta`);
        }

        // event log ของสถานะโต๊ะ (ดู modules/pos/stores/tableStatesEvents.ts)
        function tableStatesEventsRef() {
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/tableStatesEvents`);
        }

        function productsRef(){
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/products`);
        }

        function handshakeRef(){
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/handshake`);
        }

        function jobRequestRef() {

            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/jobRequest`);
        }


        function printPreviewRequestRef() {

            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/requestPrintPreview`);
        }        

         
        function settingsRef() {

            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/settings`);
        }

        function employeesRef() {

            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/employees`);
        }

        function qrcodeOrdersRef() { 
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/qrcode_orders`);
        }


        function shopNameRef() { 
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/_name`);
        }

        function onlineRef(computerRef :string) { 
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/online/${computerRef}`);

        }


        function _createRef(key: string) { 
            const db = getDatabase();

            return ref(db, `stores/${storeId.value}/${key}`);
        }

        return {
            storeId,
            setStoreId,
            getStoreId: () => storeId.value,
            jobchainRef,
            itemsRef,
         
            summaryRef,
            tablesRef,
            tableStateRef,
            tableMetaRef,
            tableStatesEventsRef,
            productsRef,
            handshakeRef,
            jobRequestRef,
            settingsRef,
            employeesRef,
            qrcodeOrdersRef,
            shopNameRef,
            onlineRef ,
            _createRef,
            printPreviewRequestRef
        }
    }
)

export const useFirebaseAnalytic = createGlobalState(
    () => {
        // state
        

        function activeStoresRef() {
            const db = getDatabase();

            return ref(db, `analytic/activeStores`);
        }

        
        return { 
            activeStoresRef
        }

 
    }
)


export const useFirebaseFirestore = createGlobalState(

    () => {
        // state
        const storeId = refVue(null)

        const JOBS_BATCH_MAX_OPS = 450;           // writeBatch จำกัด 500 ops เผื่อไว้หน่อย

        return {
            setStoreId,
            getStoreid: () => storeId.value,
            collectionRef,
            collectionDocIdRef,
            subCollectionRef,
            subCollectionDocIdRef,            
            addDayJobs,
            voidItemCollectionRef,          
            soldoutProductCollectionRef,   
            businessSessionDocRef,
            changeProductPriceCollectionRef, 
            openMenuCollectionRef,
            taxInvoiceRef,
            storeDocRef,
            appControlStoreDocRef,
            appControlDocRef,
            setTaxInvoice,
            collectionBetaWhiteList,   
            pairingTokenRef,
            receiptCounterDocRef,
            receiptCounterNonceDocRef,
            onSnapshotCollection
        }
        function setStoreId(id) {
            storeId.value = id;
        }

        // id ส่งมาเองได้ หน้า login เช็คก่อน registerModule() จะตั้ง storeId ให้
        function collectionBetaWhiteList(id = storeId.value) {
            const db = getFirestore();
            const docRef = doc(db, "beta_whitelist", id);
            return docRef;
        } 


        /**
         * doc ของ businessDate+shift เดิมที่ไม่ได้อยู่ในชุดที่กำลังจะเขียน ต้องลบทิ้ง
         * ครอบคลุม 2 เคส: chunk เก่าที่เกินมาเวลาปิดร้านซ้ำแล้วรอบใหม่ได้ chunk น้อยลง
         * และ doc v1 เดิมที่ id ไม่มี suffix `:NNN` ซึ่งถ้าปล่อยไว้จะถูกนับซ้ำ
         *
         * ถ้า query ไม่ผ่าน ให้ข้ามการเก็บกวาดไป — การเซฟข้อมูลสำคัญกว่าความสะอาด
         */
        async function findStaleJobDocIds(jobsCollection, businessDate, shift, keepIds: Set<string>) {
            try {
                const snapshot = await getDocs(
                    query(jobsCollection, where("businessDate", "==", businessDate))
                );

                const stale: string[] = [];

                snapshot.forEach((snap) => {
                    if (keepIds.has(snap.id)) return;
                    if (snap.data()?.shift !== shift) return;
                    stale.push(snap.id);
                });

                return stale;
            } catch (error) {
                console.error("addDayJobs: หา doc ค้างไม่สำเร็จ ข้ามการเก็บกวาด", error);
                return [];
            }
        }

        /**
         * job ทั้งวันของ 1 shift -> Firestore
         *
         * การแบ่ง chunk เป็น logic บริสุทธิ์ อยู่ที่ useJobsChunk.ts
         * ตรงนี้รับผิดชอบแค่การคุยกับ Firestore
         */
        async function addDayJobs(baseDocId, data) {
            const db = getFirestore();
            const jobsCollection = collection(db, "stores", storeId.value, "jobs");

            const { businessDate, shift } = data || {};
            const documents = buildJobChunkDocs(baseDocId, data);

            const keepIds = new Set(documents.map((item) => item.id));
            let staleIds = await findStaleJobDocIds(jobsCollection, businessDate, shift, keepIds);

            // ถ้าจะเกินโควต้า batch ให้ยอมทิ้งการลบก่อน การเขียนข้อมูลห้ามพลาด
            if (documents.length + staleIds.length > JOBS_BATCH_MAX_OPS) {
                staleIds = staleIds.slice(0, Math.max(0, JOBS_BATCH_MAX_OPS - documents.length));
            }

            const batch = writeBatch(db);

            documents.forEach((item) => batch.set(doc(jobsCollection, item.id), item.payload));
            staleIds.forEach((id) => batch.delete(doc(jobsCollection, id)));

            // all-or-nothing จะได้ไม่เหลือข้อมูลครึ่งวันให้รายงานอ่านไปผิด ๆ
            return batch.commit();
        }


        function voidItemCollectionRef() {
            const db = getFirestore();
            return collection(db, "stores", storeId.value, 'voidItem');  
            
        }

        function openMenuCollectionRef() {
            const db = getFirestore();
            return collection(db, "stores", storeId.value, 'openMenu');              
        }        


        function soldoutProductCollectionRef() {
            const db = getFirestore();
            return doc(db, "stores", storeId.value, 'appState','soldout');          
        }

        /**
         * ทะเบียนรอบการขายปัจจุบันของร้าน { businessDates[], openJobIds[], openedAt[] }
         *
         * เปิดร้าน = append อย่างเดียว / Main Cashier ปิดร้าน = ลบทั้ง doc
         * เครื่องที่ถือ OPEN ของรอบที่ปิดไปแล้ว (เช่น notebook ที่พับจอข้ามวัน)
         * จะรู้ตัวจาก doc นี้ แล้วห้ามออกใบเสร็จจนกว่าจะโหลดใหม่ (ดู jobs.ts computedSessionStale)
         */
        function businessSessionDocRef() {
            const db = getFirestore();
            return doc(db, "stores", storeId.value, 'appState', 'businessSession');
        }

        function changeProductPriceCollectionRef() {
            const db = getFirestore();
            return collection(db, "stores", storeId.value, 'changeProductPrice');  
            
        }
        
        /**
         * ตัวนับเลขใบเสร็จรายเดือน { value } — doc เดียวต่อเดือน ดู stores/receiptIdCounter.ts
         */
        function receiptCounterDocRef(yyyymm: string) {
            const db = getFirestore();
            return doc(db, "stores", storeId.value, "receiptCounters", yyyymm);
        }

        // marker กันนับซ้ำ 1 doc ต่อบิล (TTL policy ที่ field expireAt ลบให้เอง)
        function receiptCounterNonceDocRef(yyyymm: string, nonce: string) {
            const db = getFirestore();
            return doc(db, "stores", storeId.value, "receiptCounters", yyyymm, "nonces", nonce);
        }

        function pairingTokenRef( tokenId ) {
            const db = getFirestore();
            const docRef = doc(db, "pairing_tokens", tokenId);
            return docRef;
        }

        function taxInvoiceRef(_storeId) {            
            const db = getFirestore();
            return doc(db, "stores", _storeId);    
        }

        // root doc ร้าน stores/{storeId} — ห้าม onSnapshot doc นี้ เพราะ root doc ถูกเขียนถี่
        // (ทุกการเขียน = 1 read ต่อเครื่องที่ฟัง) คำสั่งเฉพาะร้านไปฟังที่ appControlStoreDocRef แทน
        function storeDocRef(_storeId: string) {
            const db = getFirestore();
            return doc(db, "stores", _storeId);
        }

        // คำสั่งเฉพาะร้าน app_control_stores/{storeId} → { reload } (ดู appControl.client.ts)
        // รับ storeId ตรง ๆ ไม่อิง state ภายใน เพราะ plugin ต้อง subscribe ใหม่ทันทีที่สลับร้าน
        function appControlStoreDocRef(_storeId: string) {
            const db = getFirestore();
            return doc(db, FIRESTORE_COLLECTIONS.APP_CONTROL_STORES, _storeId);
        }

        // คำสั่งระดับ channel app_control/{docId} → { reload, announcement, stock_checkpoint }
        function appControlDocRef(docId: string) {
            const db = getFirestore();
            return doc(db, FIRESTORE_COLLECTIONS.APP_CONTROL, docId);
        }

        async function setTaxInvoice(data, _storeId) {
            const db = getFirestore();
            const docRef = doc(db, "stores", _storeId);            
            return await setDoc(docRef, { taxInfo: data }, { merge: true }); 
        }
            

        function collectionRef(collectionName) {
            const db = getFirestore();
            const collectionRef  = collection(db, collectionName  );
            return collectionRef;
        }

        function collectionDocIdRef(collectionName, docId) {
            const db = getFirestore();
            const docRef = doc(db, collectionName, docId);
            return docRef;
        }

        function subCollectionRef (subCollectionName : string) {
            const db = getFirestore();
            const collectionRef  = collection(db, `stores/${storeId.value}/${subCollectionName}`);
            return collectionRef;
        }


        function subCollectionDocIdRef (subCollectionName : string, docId : string) {
            const db = getFirestore();
            const docRef = doc(db, `stores/${storeId.value}/${subCollectionName}`, docId);
            return docRef;
        }
        

        /**
         * onError ใส่ไว้ให้ผู้เรียกที่ "ต่อไม่ติดก็ไม่เป็นไร" ดักเองได้
         * ถ้าไม่ส่งมา Firestore จะโยน error ออกไปที่ console เหมือนเดิม (ไม่เปลี่ยนของเก่า)
         */
        function onSnapshotCollection (collectionName:string, id: string, callback: (payment:any) => void, onError?: (error: Error) => void): Unsubscribe {
            const db = getFirestore();
            const docRef = doc(db, collectionName, id)

            const unsub = onSnapshot(docRef, (doc) => {
              const data = doc.data()
              callback(data)
            }, (error) => {
              if (!onError) throw error
              onError(error)
            })

            return unsub
          }

    }
)
 